import { render, staticRenderFns } from "./announcement.vue?vue&type=template&id=bb85d888&scoped=true"
import script from "./announcement.vue?vue&type=script&lang=js"
export * from "./announcement.vue?vue&type=script&lang=js"
import style0 from "./announcement.vue?vue&type=style&index=0&id=bb85d888&prod&scoped=true&lang=css"
import style1 from "./announcement.vue?vue&type=style&index=1&id=bb85d888&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb85d888",
  null
  
)

export default component.exports